import React from 'react';

export default class Navigation extends React.Component {

    render() {
        const isAdmin = Boolean(this.props.account) ? this.props.account.admin : false;
        const path = window.location.pathname.split('/')[1];
        return (
            <nav className="bg-white px-8 pt-2 shadow-lg">
                <div className="sm:flex justify-between">
                    <div className="text-center">
                        <img
                            className="inline-block mb-2"
                            style={{ maxHeight: 50 }} src={require('../assets/WestRoom.png')} alt="West Cancer Spark"/>
                    </div>
                    <div className="-mb-px flex flex-row flex-wrap sm:flex-no-wrap justify-center">
                        <a
                            onClick={() => this.props.history.push('/home')}
                            className={`${path === 'home' ? 'sm:border-west-green' : 'border-transparent'} w-1/2 text-center text-gray-700 cursor-pointer no-underline sm:border-b-4 uppercase tracking-wide font-bold text-xs py-3 sm:mr-8 sm:block`}>
                            Home
                        </a>
                        <a
                            onClick={() => this.props.history.push('/ideas')}
                            className={`${path === 'ideas' ? 'sm:border-west-green' : 'border-transparent'} w-1/2 text-center text-gray-700 cursor-pointer no-underline sm:border-b-4 uppercase tracking-wide font-bold text-xs py-3 sm:mr-8 sm:block`}>
                            Ideas
                        </a>
                        <a
                            onClick={() => this.props.history.push('/posts')}
                            className={`${path === 'posts' ? 'sm:border-west-green' : 'border-transparent'} w-1/2 text-center text-gray-700 cursor-pointer no-underline sm:border-b-4 uppercase tracking-wide font-bold text-xs py-3 sm:mr-8 sm:block`}>
                            Blog
                        </a>
                        <a
                            onClick={() => this.props.history.push('/contests')}
                            className={`${path === 'contests' ? 'sm:border-west-green' : 'border-transparent'} w-1/2 text-center text-gray-700 cursor-pointer no-underline sm:border-b-4 uppercase tracking-wide font-bold text-xs py-3 sm:mr-8 sm:block`}>
                            Contests
                        </a>
                        <a
                            onClick={() => this.props.history.push('/cheers')}
                            className={`${path === 'cheers' ? 'sm:border-west-green' : 'border-transparent'} w-1/2 text-center text-gray-700 cursor-pointer no-underline sm:border-b-4 uppercase tracking-wide font-bold text-xs py-3 sm:mr-8 sm:block`}>
                            Cheers
                        </a>
                        <a
                            onClick={() => this.props.history.push('/account')}
                            className={`${path === 'account' ? 'sm:border-west-green' : 'border-transparent'} w-1/2 text-center text-gray-700 cursor-pointer no-underline sm:border-b-4 uppercase tracking-wide font-bold text-xs py-3 sm:mr-8 sm:block`}>
                            Account
                        </a>
                        {isAdmin &&
                            <a
                                onClick={() => this.props.history.push('/admin')}
                                className={`${path === 'admin' ? 'sm:border-west-green' : 'border-transparent'} w-1/2 text-center text-gray-700 cursor-pointer no-underline sm:border-b-4 uppercase tracking-wide font-bold text-xs py-3 sm:mr-8 sm:block`}>
                                Admin
                            </a>
                        }
                        <a
                            onClick={() => this.props.history.push('/logout')}
                            className={`border-transparent w-1/2 text-center text-gray-700 cursor-pointer no-underline sm:border-b-4 uppercase tracking-wide font-bold text-xs py-3 sm:mr-8 sm:block`}>
                            Logout
                        </a>
                    </div>
                </div>
            </nav>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/navigation.js